import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import errorJson from '../../animations/error.json';
import { SemanticColor, semanticColorsV1 } from '../../theme/colors';
import { LottieAnimationViewV1 } from './LottieAnimationViewV1';

/** v1 design of error animation (as in master): `error.json` recolored with `IconError`. Rendered for widgets without `version: 2`. */
export const ErrorAnimationV1 = ({ widget }: TWidgetProps<TCommonData>) => {
    return (
        <LottieAnimationViewV1
            dataTest={widget.uid}
            animationData={errorJson}
            animationsColor={semanticColorsV1[SemanticColor.IconError]}
            loop={false}
            size="73px"
            margin={widget.options?.margin}
        />
    );
};
